import React from 'react'
import { Route, Routes } from "react-router-dom"
import RouteShipmentCreateScreen from "screens/App/CRM/RouteShipment/RouteShipmentCreateScreen"
import RouteShipmentListScreen from "screens/App/CRM/RouteShipment/RouteShipmentListScreen"
import RouteShipmentDetailScreen from "screens/App/CRM/RouteShipment/RouteShipmentDetailScreen"
import RouteShipmentEditScreen from "screens/App/CRM/RouteShipment/RouteShipmentEditScreen"
import NotFoundScreen from "screens/NotFoundScreen"

const RouteShipmentRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<RouteShipmentCreateScreen />} />

      <Route path="list" element={<RouteShipmentListScreen />} />

      <Route path=":id/detail" element={<RouteShipmentDetailScreen />} />

      <Route path=":id/edit" element={<RouteShipmentEditScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  )
}

export default RouteShipmentRouter;
